import { useCalcCost } from "@erp/shared/components/ui/Document/_composable/useCalcCost";
import { defineStore } from "pinia";
export const useObtainCalcCostInfoStore = defineStore("obtainCalcCostInfo", useCalcCost);
